module.exports = "<p>\n  login works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/Angular/Urbanos/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main